module.exports = __webpack_public_path__ + "static/media/31JFA5.5bed4fc4.jpg";